import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDebounce } from "react-use";

export const useSearchTerm = (debounceMs: number = 300) => {
  const navigate = useNavigate();
  const location = useLocation();

  // Get search term from URL search parameters
  const searchParams = new URLSearchParams(location.search);
  const searchTerm = searchParams.get("search") || "";

  // Function to update search term in URL
  const setSearchTerm = (term: string) => {
    const newSearchParams = new URLSearchParams(location.search);
    if (term.trim()) {
      newSearchParams.set("search", term);
    } else {
      newSearchParams.delete("search");
    }
    const newSearch = newSearchParams.toString();
    const newPath = newSearch
      ? `${location.pathname}?${newSearch}`
      : location.pathname;
    navigate(newPath, { replace: true });
  };

  // Local state for the search input to enable debouncing
  const [searchInput, setSearchInput] = useState<string>(searchTerm);

  // Update local input when URL search term changes (e.g., browser back/forward)
  useEffect(() => {
    setSearchInput(searchTerm);
  }, [searchTerm]);

  // Debounced function to update URL with search term
  useDebounce(
    () => {
      setSearchTerm(searchInput);
    },
    debounceMs,
    [searchInput]
  );

  return {
    searchTerm,
    searchInput,
    setSearchInput,
  };
};
